package playground.gradient

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.unit.IntSize
import androidx.compose.ui.unit.dp
import playground.gradient.data.ColorStop
import playground.gradient.data.Gradient
import playground.gradient.ui.ColorStopEditor
import playground.gradient.ui.CopyGradientCodeButton
import playground.gradient.ui.GradientTypePicker
import playground.gradient.ui.HSVColorPicker
import playground.gradient.ui.RGBColorPicker
import playground.gradient.ui.StartEndDragHandle
import playground.gradient.ui.createLinearShaderBrush
import playground.gradient.ui.createRadialShaderBrush
import playground.gradient.ui.createSweepShaderBrush

const val GRADIENT_PLAYGROUND = "0252b7c395c373cea16f9773f7606713855d765aa8a26b5a3d80fd69baef2b40"

@Composable
fun GradientPlayground() {

    Row(
        modifier = Modifier
//            .fillMaxSize()
            .widthIn(max = 900.dp)
    ) {

        var selectedStopId by remember { mutableStateOf(0L) }

        var stops by remember {
            mutableStateOf(
                listOf(
                    ColorStop(0.2f, Color.Cyan),
                    ColorStop(0.5f, Color.Yellow),
                    ColorStop(0.8f, Color.Magenta),
                )
            )
        }

        var gradientType: Gradient by remember {
            mutableStateOf(Gradient.Linear)
        }

        LaunchedEffect(selectedStopId, stops.size) {
            if (stops.isNotEmpty())
                if (selectedStopId == 0L || !stops.any { selectedStopId == it.id }) {
                    stops.firstOrNull()?.id?.let {
                        selectedStopId = it
                    }
                }
        }

        var start by remember { mutableStateOf(Offset(0f, 0f)) }
        var end by remember { mutableStateOf(Offset(1f, 1f)) }
        var center by remember { mutableStateOf(Offset(.5f, .5f)) }


        Column(
            modifier = Modifier
                .align(Alignment.CenterVertically)
                .weight(1f)
                .padding(5.dp),
            verticalArrangement = Arrangement.Center
        ) {
            var intSize by remember { mutableStateOf(IntSize.Zero) }
            Box(
                Modifier
                    .aspectRatio(1f)
                    .fillMaxWidth()
                    .onSizeChanged {
                        intSize = it
                    }
                    .background(
                        brush = when (gradientType) {
                            Gradient.Linear -> createLinearShaderBrush(
                                colorStops = stops,
                                start = start,
                                end = end,
                            )

                            Gradient.Radial -> createRadialShaderBrush(
                                colorStops = stops,
                                center = center,
                                radius = 1f,
                            )

                            Gradient.Sweep -> createSweepShaderBrush(
                                colorStops = stops,
                                center = center,
                            )
                        },
                        shape = RoundedCornerShape(24.dp)
                    )
            ) {
                when (gradientType) {
                    Gradient.Linear -> {
                        StartEndDragHandle(
                            anchor = start,
                            setAnchor = {
                                start = it
                            },
                            dragAreaIntSize = intSize,
                        )
                        StartEndDragHandle(
                            anchor = end,
                            setAnchor = {
                                end = it
                            },
                            dragAreaIntSize = intSize,
                        )
                    }

                    Gradient.Radial, Gradient.Sweep -> {
                        StartEndDragHandle(
                            anchor = center,
                            setAnchor = {
                                center = it
                            },
                            dragAreaIntSize = intSize,
                        )
                    }
                }
            }
            Spacer(Modifier.height(8.dp))

            ColorStopEditor(
                stops = stops,
                stopIndex = selectedStopId,
                onColorStopSelected = {
                    selectedStopId = it
                },
                onColorStopsChanged = {
                    stops = it
                }
            )
        }

        Column(
            Modifier
                .fillMaxHeight()
                .weight(1f),
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            stops.find { selectedStopId == it.id }.let { colorStop ->
                RGBColorPicker(
                    color = colorStop?.color ?: Color.White,
                    setColor = {
                        if (colorStop != null) {
                            stops = stops.mapIndexed { index, colorStop ->
                                if (colorStop.id == selectedStopId) {
                                    colorStop.copy(
                                        color = it
                                    )
                                } else colorStop

                            }
                        }
                    }
                )

//                HSVColorPicker(
//                    color = colorStop?.color ?: Color.White,
//                    setColor = {
//                        if (colorStop != null) {
//                            stops = stops.mapIndexed { index, colorStop ->
//                                if (colorStop.id == selectedStopId) {
//                                    colorStop.copy(
//                                        color = it
//                                    )
//                                } else colorStop
//
//                            }
//                        }
//                    }
//                )


            }

            GradientTypePicker(
                currentGradientType = gradientType,
                setGradientType = {
                    gradientType = it
                }
            )

            CopyGradientCodeButton(
                gradient = gradientType,
                stops = stops,
                start = start,
                end = end,
                center = center,
            )
        }
    }
}

